<template>
  <div class="net-value">
    <el-card>
      <div slot="header" class="clearfix">
        <span>费用返还</span>
        <date-range style="float: right" v-on:change="getData"></date-range>
      </div>
      <h-chart ref="chart" id="chart" :options="options"></h-chart>
      <div class="blackboard">
        <p class="star-level"><span class="label">指标星级：</span>
          <el-rate v-model="starLevel" disabled></el-rate>
        </p>
        <p><span class="label">指标释义：</span>反映该账户的每日费用返还信息</p>
        <p><span class="label">如何使用：</span>从费用返还图走势，可以直观了解投资人的账户费用返还情况，帮助投资人更好的了解账户费用返还规模变动。
        </p>
      </div>
    </el-card>
  </div>
</template>

<script>
import HChart from '@/components/HChart.vue';
import DateRange from '@/components/DateRange.vue';
import {Loading} from 'element-ui';
import {apiAnalysisData} from "../../api/analysis";
import {mapState} from "vuex";

export default {
  name: "FeeRefund",
  data() {
    return {
      starLevel: 4,
      options: {
        credits: {
          enabled: false
        },
        title: '',
        chart: {
          zoomType: 'x',
          resetZoomButton: {
            // relativeTo: 'chart',
            position: {
              // align: 'right', // by default
              // verticalAlign: 'top', // by default
              x: 0,
              y: -35
            }
          },
          spacingTop: 35,
          backgroundColor: null,
          plotBackgroundColor: null
          // backgroundColor: '#ededed',
        },
        plotOptions: {
          series: {
            cursor: 'default'
          }
        },
        colors: [
          '#EB3E41', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80',
          '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa',
          '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050',
          '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'
        ],
        xAxis: {
          // tickInterval: 20,
          categories: []
        },
        yAxis: {
          title: false,
        },
        series: [],
      },
    };
  },
  components: {
    HChart,
    DateRange
  },
  computed: {
    ...mapState(["analysisType", "curAccountId", "dateRange"]),
    curAccountInfo() {
      return {
        analysisType: this.analysisType,
        curAccountId: this.curAccountId,
      }
    }
  },
  watch: {
    curAccountInfo: {
      immediate: true,
      handler(newVal, oldVal) {
        if(oldVal !== undefined) {
          this.getData();
        }
      }
    },
  },
  methods: {
    async getData() {
      if (this.curAccountId.length === 0) {
        return false;
      }
      let loadingInstance = Loading.service({target: '.h-chart'});
      const params = {
        a_id: this.curAccountId.join(','),
        type: this.analysisType,
        b_date: this.dateRange.b_date,
        e_date: this.dateRange.e_date
      }
      let res = await apiAnalysisData('feeReturn', params)
      loadingInstance.close();
      if (res.data.code === 0) {

        let categories = []
        let f1s = []

        if (res.data.data) {
          const resData = JSON.parse(JSON.stringify(res.data.data));
          resData.map(item => {
            if (item.date) {
              categories.push(item.date)
            }
            if (item.f1 || item.f1 === 0) {
              f1s.push(item.f1)
            }
          })
        }

        this.options.xAxis.categories = categories;
        this.options.series = [{
          name: '费用返还',
          data: f1s
        }];
        this.$refs.chart.redraw();
      }
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style lang="scss">
.net-value {
  .el-card {
    border: 0;

    .el-card__header {
      background: #1777FF;
      color: #ffffff;
    }

    .chart {
      margin-bottom: 20px;
      background-image: url("../../assets/watermark.png");
      background-repeat: no-repeat;
      background-size: 269px 150px;
      background-position: center;
    }
  }
}
</style>

